import { useMemo } from 'react'

import { AppGroup } from 'shared/constants/apps'
import { AppConfig } from 'shared/types/app'

import { useInitializeGroupAppOrder } from './useInitializeGroupAppOrder'

export const APP_GROUPS: AppGroup[] = Object.values(AppGroup)

export interface UseTopDockAppsReturn {
  appsByGroup: Array<{ [K in AppGroup]?: AppConfig[] }>
  flattenedApps: AppConfig[]
  appIndexMap: Map<string, number>
  isLoading: boolean
}

export const useTopDockApps = (): UseTopDockAppsReturn => {
  const { appsByGroup, isLoading } = useInitializeGroupAppOrder()
  const flattenedApps = useMemo(
    () =>
      appsByGroup.flatMap(group =>
        Object.values(group)?.[0]?.flatMap(app => app)
      ),
    [appsByGroup]
  )

  const appIndexMap = useMemo(
    () => new Map(flattenedApps.map((app, index) => [app.name, index])),
    [flattenedApps]
  )

  return {
    appsByGroup,
    flattenedApps,
    appIndexMap,
    isLoading
  }
}
